import { createGlobalStyle, ThemeProps } from "styled-components";
import reset from "styled-reset";
import { normalize } from "styled-normalize";
import { Theme } from "../models/theme";

export const GlobalStyle = createGlobalStyle<ThemeProps<Theme>>`  
  ${reset}
  ${normalize}

  :root {
    font-size: 62.5%;
  }

  html {
    box-sizing: border-box;
    height: 100%;
    // overflow: hidden;
  }

  body {
    font-family: 'Boots Sharp';
    font-weight: 300;
    font-size: 1.8rem;
    color: #05054B;
    position: relative;
    z-index: 0;
    overflow: auto;
    height: 100%;

    /* width */
    &::-webkit-scrollbar {
      width: 4px;
      display: none;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.colors.white};
    }

    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.hotPink};
      border-radius: 8px;
    }

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => theme.colors.pink};
    }
  }

  // Used to make the menu on a lower z-index clickable 
  // requires making pointer events clickable in all layout components
  #root {
    pointer-events: none;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  h1, h2 {
    font-weight: 700;
    margin: 0;
  }

  h1 {
    font-size: 8rem;
    line-height: 1.1em;
  }
  h2 {
    font-size: 6.4rem;
  }

  p {
    line-height: 1.75em;
  }

  a {
    color: inherit;
    text-decoration: none;
  }
`;
